module.exports = __webpack_public_path__ + "img/tuijian@2x.png?v=38fb7a28";